import { connect } from 'react-redux';
import RootStoreContext from '~/contexts/RootStoreContext';
import { selectors as commonSelectors } from '~/domains/common';
import { selectors as featureFlagsSelectors } from '~/domains/featureFlags';
import { REMOVE_MULESOFT_ORG_REVIEWS_ENABLED } from '~/domains/featureFlags/keys';
import Card from './Card';

const mapRootStateToProps = (state) => {
  const featureFlags = featureFlagsSelectors.featureFlags(state);
  const isRemoveMulesoftOrgReviewsEnabled =
    featureFlags?.[REMOVE_MULESOFT_ORG_REVIEWS_ENABLED];

  return {
    isRemoveMulesoftOrgReviewsEnabled,
    homeQuery: commonSelectors.homeQuery(state)
  };
};

export default connect(mapRootStateToProps, null, null, {
  context: RootStoreContext
})(Card);
